import React, { useState } from 'react';

export default function WritingPrompt({ question, answer, onAnswer }) {
  const [wordCount, setWordCount] = useState(0);
  
  const handleChange = (e) => {
    const text = e.target.value;
    const words = text.trim().split(/\s+/).filter(word => word.length > 0);
    setWordCount(words.length);
    onAnswer(question.id, text);
  };
  
  const isWithinRange = wordCount >= (question.minWords || 0) && wordCount <= (question.maxWords || 999);
  
  return (
    <div className="bg-white p-6 rounded-lg border border-gray-200 shadow-sm">
      <div className="mb-4">
        <h3 className="font-semibold text-lg text-gray-900 mb-2">Writing Task</h3>
        <p className="text-gray-700 mb-2">{question.question}</p>
        <p className="text-sm text-gray-500">
          Required: {question.minWords}-{question.maxWords} words
        </p>
      </div>
      
      <textarea
        value={answer || ''}
        onChange={handleChange}
        className="w-full h-48 p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
        placeholder="Type your answer here..."
      />
      
      <div className="mt-2 flex justify-between items-center">
        <span className={`text-sm font-medium ${isWithinRange ? 'text-green-600' : 'text-red-600'}`}>
          Word count: {wordCount}
        </span>
        {!isWithinRange && wordCount > 0 && (
          <span className="text-xs text-red-500">
            {wordCount < question.minWords ? 'Too few words' : 'Too many words'}
          </span>
        )}
      </div>
    </div>
  );
}
